import { IconButton } from '@dixa/lib-shared-habla';
import FileSaver from 'file-saver';
import * as React from 'react';

import '../../styles/attachments-field.less';
import { ajaxSend } from '../../../../../../api/api';
import {
  getFileSize,
  isPreviewableAttachment,
} from '../../../../../../app/utils/attachments';

type PropsT = {
  fields: any;
  previewImage: any;
};

class AttachmentsFieldList extends React.Component<PropsT> {
  fetchPrivateFileBlob = (url: string): Promise<Blob> => {
    return ajaxSend<Blob>({
      path: url,
      responseType: 'blob',
    });
  };

  fetchPrivateFile = (fileName: string, url: string) => {
    this.fetchPrivateFileBlob(url)
      .then((blob) => {
        FileSaver.saveAs(
          blob,
          decodeURIComponent(fileName.split('/').pop() as string),
        );
      })
      .catch((e) => {
        console.error(e);
      });
  };

  previewPrivateFile = (fileName: string, url: string) => {
    const { previewImage, fields } = this.props;
    this.fetchPrivateFileBlob(url)
      .then((blob) => window.URL.createObjectURL(blob))
      .then((blobUrl) => {
        // Create array of all attachments for navigation
        const allAttachments = fields.map((field: any, index: number) => ({
          fileName: fields.get(index).name,
          url: fields.get(index).absolute_uri,
        }));

        // Find current attachment index
        const currentIndex = allAttachments.findIndex(
          (att) => att.fileName === fileName && att.url === url,
        );

        previewImage({
          fileName,
          url: blobUrl,
          attachments: allAttachments,
          currentIndex: currentIndex >= 0 ? currentIndex : 0,
        });
      })
      .catch((e) => {
        console.error(e);
      });
  };

  render() {
    const { fields } = this.props;
    const attachments = fields.map((f: any, i: number) => fields.get(i));

    return (
      <div className={`attachments-field-list `}>
        {attachments.length > 0 && (
          <React.Fragment>
            <div className="file-header">Attached file(s)</div>
            <ul className="file-list">
              {fields.map((field: any, index: number) => (
                <li key={index} className="file-item">
                  <p className="file-text">
                    <span className="file-name">{fields.get(index).name}</span>
                    {!!fields.get(index).size && (
                      <span className="file-size">{`[${getFileSize(
                        fields.get(index).size,
                      )}]`}</span>
                    )}
                  </p>
                  <div className="file-item__actions">
                    {isPreviewableAttachment(fields.get(index).name) && (
                      <IconButton
                        className="file-item__action"
                        variant="tertiary"
                        icon="eye"
                        onClick={() =>
                          this.previewPrivateFile(
                            fields.get(index).name,
                            fields.get(index).absolute_uri,
                          )
                        }
                      />
                    )}
                    {!!fields.get(index).absolute_uri && (
                      <IconButton
                        className="file-item__action"
                        variant="tertiary"
                        icon="download"
                        onClick={() =>
                          this.fetchPrivateFile(
                            fields.get(index).name,
                            fields.get(index).absolute_uri,
                          )
                        }
                      />
                    )}

                    <IconButton
                      className="file-item__action"
                      onClick={(
                        event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
                      ) => {
                        event.stopPropagation();
                        fields.remove(index);
                      }}
                      variant="tertiary"
                      icon="trash"
                    />
                  </div>
                </li>
              ))}
            </ul>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default AttachmentsFieldList;
